<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title-logo">
               {{ $t('receive') }}
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                @click.passive="onClickBack()"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 시세창 -->
        <div class="price-box">
            <img 
            src="@/assets/price_bg.png"
            class="img-price-box"> 
            <div class="txt-eth-price">{{this.mSymbol}}  {{ $t('market_price') }}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'krw'">{{this.mCoinPriceKRW}}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'usd'">{{this.mCoinPriceUSD}}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'krw'">{{ $t('krw_won') }}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'usd'">{{ $t('usd') }}</div>
        </div> 
        <!-- 디지파이넥스로고 -->
        <div class="css-img-digifinex"
        v-ripple="{ center: true, class: `teal--text`  }">
            <img 
            src="@/assets/digifinex_logo.png"
            class="img-digifinex-logo"> 
        </div>   
        <div class="css-txt-digifinex">{{ $t('support') }}</div>   
        <!-- 이더로고 -->
        <div class="ether-logo-position">
            <img 
            :src="this.mIconUrl"
            class="img-ether-logo"> 
        </div>    
        <!-- 이더량 -->
        <div class="ether-amount">{{ $satoshiUtil.satoshiToMCH(this.mBalance) }} {{this.mSymbol}}</div>   
        <!-- 라인 -->
        <div class="bottom-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue01-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue02-line"></div>        
        <!-- qr코드 -->
        <div class="qrcode-box">
            <qrcode-vue :value="mAddress" :size="qrcodeSize" level="H"></qrcode-vue>
        </div>
        <div class="txt-qrcdoe">{{ $t('show_qrcode_info') }}</div>
        <!-- eth지갑 주소 -->
        <div class="txt-eth-address">{{this.mSymbol}} {{ $t('address_wallet') }}</div>
        <!-- 지갑주소 창 -->
        <div class="txt-address-bg">
            <img 
            src="@/assets/address_box_bg.png"
            class="img-address-bg"> 
            <div class="txt-address">{{this.mAddress}}</div>
        </div> 
        <!-- 주소복사 -->
        <div class="btn-copy-address"
        @click.passive="onClickCopy()"
        v-ripple="{ center: true, class: `teal--text`  }">
            <img 
            src="@/assets/btn_copy_address.png"
            class="img-copy-address"> 
        </div>  
        
        <div class="txt-copy-address"> {{ $t('copy_address') }}</div>        
        <!-- 로딩바 -->
        <div class="loading-bar-postion" v-show="mShowLoading">
            <v-progress-circular
            indeterminate
            color="red"
            ></v-progress-circular>
        </div>
    </v-app>
</template>
<script>
import axios from 'axios';
import QrcodeVue from 'qrcode.vue';
export default {
    created() {
        let payload = this.$route.query.payload;
        let decrypto = this.$cryptoUtil.decrptoMessage(payload);
        let json = JSON.parse(JSON.parse(decrypto));
        this.mMno = json.mno;
        this.mCoinType = json.coin_type;
        this.mSymbol = json.symbol;
        this.mSymbol = this.mSymbol.toUpperCase();
        this.mIconUrl = json.icon_url;
        this.mAddress = json.address;
        this.marketPrice();
        this.qrcodeSize = screen.width * 0.45;
    },
    data: () => ({
        mMno : "",
        mPasswd : "",
        mCoinType : "",
        mSymbol : "",
        mCoinPriceKRW : "",
        mCoinPriceUSD : "",
        mShowLoading : false,
        mBalance : "",
        mAddress : "",
        qrcodeSize : 100,
    }),
    components: {
        QrcodeVue
    },
    methods : {
    onClickBack : function() {
        this.$router.go(-1);
    },
    marketPrice : function() {
        let payload = {};
        payload.cmd = "get-market-price";
        payload.mno = this.mMno;
        payload.coin_type = this.mCoinType;
        
        this.mShowLoading = true;
        axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
        .then(response => {
            console.log(response);
            this.mShowLoading = false;
            let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));
            if(serverResponse.result == "1") { // 성공
                this.mCoinPriceKRW = this.$currencyUtil.numberWithCommas(serverResponse.coin_price);
                this.mCoinPriceUSD = this.$currencyUtil.numberWithCommas(serverResponse.coin_price_usd);
            } else if(serverResponse.result == "2") { // 기존사용자존재
            
            } else if(serverResponse.result == "0") { // 오류
                
            }
            this.getBalance();
        })
        .catch( ()=>{} );
    },
    getBalance : function() {
        let payload = {};
        payload.cmd = "get-balance";
        payload.mno = this.mMno;
        payload.coin_type = this.mCoinType;
        
        this.mShowLoading = true;
        axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
        .then(response => {
            let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));  
            console.log(response);
            this.mShowLoading = false;
            if(serverResponse.result == "1") { // 성공
                this.mBalance = serverResponse.balance;
            } else if(serverResponse.result == "2") { // 기존사용자존재
            
            } else if(serverResponse.result == "0") { // 오류
                
            }
        })
        .catch( ()=>{} );
    },
    onClickCopy : function() {
        this.$copyText(this.mAddress).then(function (e) {
            alert('복사되었습니다.')
            console.log(e)
        }, function (e) {
            alert('Can not copy')
            console.log(e)
        })
    }
  }
}
</script>
<style scoped>
  * {
      margin: 0;
      font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
      font-weight: 300;
      padding: 0;
  }
  html, body {
    height: 100vh;
    width: 100vw;
  }
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    height: 13.24vw;
    width: 100vw;    
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title-logo {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.7vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.img-title-logo {
    height: 5.925926vw;
    width: 37.407vw;
}
.price-box {
    position: absolute;
    top: 15.37vw; 
    left: 5.6vw;
    height: 8.148vw;
    width: 88.9vw;     
}
.img-price-box {
    height: 8.148vw;
    width: 88.9vw; 
}
.txt-eth-price {
    position: absolute;
    top: 50%; 
    left: 5.5vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-value {
    position: absolute;
    top: 50%; 
    right: 14vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);       
}
.txt-eth-unit {
    position: absolute;
    top: 50%; 
    right: 6.2vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.ether-logo-position {
    position: absolute;
    top: 28.148vw; 
    left: 50%;    
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
}
.img-ether-logo {
    width: auto;
    height: 8.333vw;     
}
.ether-amount {
    position: absolute;
    top: 37.96296vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    font-family: NanumBarunGothicOTF;
    font-size: 5.092593vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;        
}
.btn-receive {
    position: absolute;
    top: 47.7777vw; 
    left: 25.6vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-send {
    position: absolute;
    top: 47.7777vw; 
    left: 43.7vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.btn-convert {
    position: absolute;
    top: 47.7777vw; 
    left: 61.9vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.img-center-icon {
    position: absolute;
    top: 50%; 
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);       
}
.txt-receive-send {
    position: absolute;
    top: 110%; 
    left: 0px;
    width: 100%;
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #757c7e;   
}
.bottom-line {
    position: absolute;
    top: 47.77778vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.bottom-blue01-line {
    position: absolute;
    top: 47.77778vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.bottom-blue02-line {
    position: absolute;
    top: 49vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.txt-history {
    position: absolute;
    top: 74.81481vw; 
    left: 5.8vw;  
    width: 62px;
    height: 20px;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
}
.img-period {
    width: 100%;
    height: 7.777vw;
}
.input-period {
    position: absolute;
    top: 81.85185vw; 
    left: 5.6vw; 
    right: 5.6vw;
}
.qrcode-box {
    position: absolute;
    top: 57.407vw; 
    left: 26vw; 
    width: 52.22vw;
    height: 52.22vw;     
}
.txt-qrcdoe {
    position: absolute;
    top: 111.11vw; 
    left: 0vw;
    width: 100vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center; 
    color:#231815;
}
.txt-eth-address {
    position: absolute;
    top: 123.37vw; 
    left: 6.2vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
}
.txt-address-bg {
    position: absolute;
    top: 127.963vw; 
    left: 5.6vw; 
    width: 88.9vw;
    height: 7.407407vw;  
}
.txt-address {
    position: absolute;
    top: 50%; 
    left: 50%; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #52595b;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);     
}
.img-address-bg {
    width: 88.9vw;
    height: 7.407407vw;
}
.btn-copy-address {
    position: absolute;
    top: 143.5185vw; 
    left: 43.148vw;  
}
.img-copy-address {
    width: auto;
    height: 13.7037vw;
}
.txt-copy-address {
    position: absolute;
    top: 159.6296vw; 
    left: 50%;  
    font-family: NanumBarunGothicOTF;
    font-size: 2.777vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #757c7e; 
    transform: translate(-50%, 0%);          
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.img-digifinex-logo {
    width: auto;
    height: 5vw; 
}

.css-img-digifinex {
    position: absolute;
    top: 24vw;
    right: 6.5vw; 
}

.css-txt-digifinex {
    position: absolute;
    top: 24.8vw;
    right: 23vw;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    color: #353535;          
}
</style>